var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-changer"},[_c('button',{staticClass:"switchBtn",domProps:{"innerHTML":_vm._s(_vm.writeLocale())},on:{"click":function($event){return _vm.switchLocale(_vm.$i18n.locale)}}},[_vm._v("change lang")])])}
var staticRenderFns = []

export { render, staticRenderFns }